import ScheduleTable from './ScheduleTable';

function SchedulePage() {



  return (
    <div className='main-Public-wrap'>

      <div className='Measurement-wrap'>

        <ScheduleTable/>

      </div>


  

      
    </div>
  );  
}

export default SchedulePage;
